export default "__VITE_PUBLIC_ASSET__58319937__"